import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { ParameterField } from '../../../../_common/platform/tsx/ParameterField';
import StringField from '../../../../_common/platform/tsx/StringField';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';
import { DataQuerySingleValueField } from '../../../../_common/application/tsx/DataQuerySingleValueField';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { CHART_STRIPS } from '../chartConstants';
import { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';
import { ChartPropsManager } from '../ChartPropsManager';

class ChartStripsFieldRow extends React.Component<
    {
        value?;
        values?;
        index?: number;
        secondaryAxisArr: any[];
        prohibitedAsPercent_byAxisType_byAxisObjX?: boolean;
        prohibitedAsPercent_byAxisType_byAxisObjY?: boolean;
        prohibitedAsPercent_byAttrQuery_X_multi?: boolean;
        prohibitedAsPercent_byAttrQuery_Y_multi?: boolean;
        themeFields_forDefaultColors?;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value, param2): void;
        onRemove?(index: number): void;
    },
    { selectedPredefinedStrip }
> {
    private references: {
        labelVerticalAlignment?: HTMLElement; // HTMLDivElement;
        labelHorizontalAlignment?: HTMLElement; // HTMLDivElement;
        type?: HTMLElement; // HTMLDivElement;
        asPercent?: HTMLElement; // HTMLDivElement;
        fromDataSourceStart?: HTMLElement; // HTMLDivElement;
        fromDataSourceEnd?: HTMLElement; // HTMLDivElement;
        selectStrip?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            selectedPredefinedStrip: null //LL: for fictiv row
        };
    }

    normalize(value) {
        if (value.type == null) {
            delete value.label;
            delete value.labelHorizontalAlignment;
            delete value.labelVerticalAlignment;
            delete value.color;
            delete value.fontColor;
            delete value.startValue;
            delete value.endValue;
            delete value.asPercent;
            delete value.name;
            return;
        }

        let find = _.find(CHART_STRIPS.labelVerticalAlignment, function (val) {
            return val === value.labelVerticalAlignment;
        });

        if (find == null) {
            delete value.labelVerticalAlignment;
        }

        find = _.find(CHART_STRIPS.labelHorizontalAlignment, function (val) {
            return val === value.labelHorizontalAlignment;
        });

        if (find == null) {
            delete value.labelHorizontalAlignment;
        }
    }

    processLabelVerticalAlignmentChange = (e) => {
        let val = (this.references.labelVerticalAlignment as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            delete obj.labelVerticalAlignment;
        } else {
            obj.labelVerticalAlignment = val;
        }

        this.handleValueChange(obj);
    };

    processLabelHorizontalAlignmentChange = (e) => {
        let val = (this.references.labelHorizontalAlignment as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            delete obj.labelHorizontalAlignment;
        } else {
            obj.labelHorizontalAlignment = val;
        }

        this.handleValueChange(obj);
    };

    processTypeChange = (e) => {
        let val = (this.references.type as HTMLInputElement).value;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});

        if (val === 'none' || val == null) {
            //LL: 'none' is disabled !
            delete obj.type;
        } else {
            obj.type = val;
        }

        this.handleValueChange(obj);
    };

    processLabelChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.label;
        } else {
            obj.label = val;
        }
        this.handleValueChange(obj);
    };

    processStartValueChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.startValue;
        } else {
            obj.startValue = val;
        }
        this.handleValueChange(obj);
    };

    processEndValueChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.endValue;
        } else {
            obj.endValue = val;
        }
        this.handleValueChange(obj);
    };

    processStartDataQueryChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.dataQueryStart;
        } else {
            obj.dataQueryStart = val;
        }
        this.handleValueChange(obj);
    };

    processEndDataQueryChange = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.dataQueryEnd;
        } else {
            obj.dataQueryEnd = val;
        }
        this.handleValueChange(obj);
    };

    processAsPercentChange = (e) => {
        let val = (this.references.asPercent as HTMLInputElement).checked;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.asPercent;
        } else {
            obj.asPercent = val;
        }
        this.handleValueChange(obj);
    };

    processFromDataSourceStartChange = (e) => {
        let val = (this.references.fromDataSourceStart as HTMLInputElement).checked;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fromDataSourceStart;
        } else {
            obj.fromDataSourceStart = val;
        }
        this.handleValueChange(obj);
    };

    processFromDataSourceEndChange = (e) => {
        let val = (this.references.fromDataSourceEnd as HTMLInputElement).checked;

        //LL: 27.05.20: for inheritance, for clearElem -> null
        if (e == null) {
            val = null;
        }

        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fromDataSourceEnd;
        } else {
            obj.fromDataSourceEnd = val;
        }
        this.handleValueChange(obj);
    };

    processFontColorChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.fontColor;
        } else {
            obj.fontColor = val;
        }
        this.handleValueChange(obj);
    };

    processColorChange_ColorBox = (val) => {
        let obj = _.clone(this.props.value || {});
        if (val == null) {
            delete obj.color;
        } else {
            obj.color = val;
        }
        this.handleValueChange(obj);
    };

    handleValueChange(value) {
        this.normalize(value);

        let param2: any = this.props.index; // for updateRow

        if (this.props.index == null && this.state != null) {
            //LL: for addRow   NEW copied
            param2 = this.state.selectedPredefinedStrip;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, param2);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.index);
        }
    };

    getRemoveButton(value) {
        if (value.type == null) {
            return;
        }

        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };

    getName(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.name || '';
        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    processStripChange = (e) => {
        let val = (this.references.selectStrip as HTMLInputElement).value;

        if (val === '') {
            //  "none"
            val = null;
        }

        this.setState(
            _.extend(this.state, {
                selectedPredefinedStrip: val
            })
        );
    };

    getPredefinedStripList(stripList) {
        let selectStripElem;

        if (stripList != null && stripList.length > 0) {
            let options = _.map(stripList, function (item: any) {
                // { item.name + " (" + item.dataType + ")" }
                return (
                    <option key={item.name} value={item.name}>
                        {item.name}
                    </option>
                );
            });

            let stripVal = this.state.selectedPredefinedStrip || '';

            if (this.state.selectedPredefinedStrip == null) {
                options.unshift(
                    <option key={' '} value={''} disabled={true}>
                        {'choose an item'}
                    </option>
                );
            } else {
                options.unshift(
                    <option key={' '} value={''}>
                        {'none'}
                    </option>
                );
            }

            selectStripElem = (
                <select
                    ref={(input) => {
                        this.references.selectStrip = input;
                    }}
                    className="form-control"
                    onChange={this.processStripChange}
                    value={stripVal}
                >
                    {options}
                </select>
            );
        }

        return selectStripElem;
    }

    getLabel(value) {
        if (value.type == null) {
            return;
        }
        return <StringField onChange={this.processLabelChange} value={value.label || ''} />;
    }

    getType(value) {
        let displayVal = value.type || 'none';
        let secondaryAxisArr = [];

        if (this.props.secondaryAxisArr != null) {
            secondaryAxisArr = this.props.secondaryAxisArr;
        }

        let arr = CHART_STRIPS.stripType.slice(0); // ['arguments', 'values']

        //LL: 02.06.20:  add 'not used' type => will not used in Chart
        arr.push(CHART_STRIPS.notUsedType);

        let removedAxisOption;

        if (displayVal != 'none') {
            let ind = _.indexOf(arr, displayVal);
            let isAux = ind < 0;
            let auxNotExist = _.indexOf(secondaryAxisArr, displayVal) < 0;

            if (isAux && auxNotExist) {
                removedAxisOption = (
                    <option key={displayVal} value={displayVal} disabled={true}>
                        {displayVal + ' removed'}
                    </option>
                );
            }
        }

        arr = arr.concat(secondaryAxisArr); //  main + aux

        let options = _.map(arr, function (value) {
            return (
                <option key={value} value={value}>
                    {value}
                </option>
            );
        });

        //LL: 02.06.20: show 'none' only when no value
        let noneOption;
        if (displayVal === 'none') {
            noneOption = (
                <option key="none" value="none" disabled={true}>
                    none
                </option>
            );
        }

        let title = '';
        if (value.type == null) {
            title = 'Choose actual Axis to create a Strip';
        }

        let style2: any = {};
        if (removedAxisOption != null) {
            style2 = { borderColor: 'red' }; // color bad, for all items in dropdown
            title = 'Axis is removed';
        }

        return (
            <select
                ref={(input) => {
                    this.references.type = input;
                }} //LL: 27.01.25
                className="form-control"
                style={style2}
                onChange={this.processTypeChange}
                value={displayVal}
                title={title}
            >
                {removedAxisOption}
                {noneOption}
                {options}
            </select>
        );
    }

    getAxisType(value) {
        if (value.type == null) {
            return;
        }

        let axisName = value.type;
        let axisType = ChartPropsManager.getAxisType(this.props.values, axisName, this.props.themeObj);

        const defName = 'automatic'; // "default"

        if (axisType == null) {
            axisType = defName;
        }

        let emphasize = false;

        if (axisType === 'discrete' || axisType === defName) {
            emphasize = true;
        }

        let style1: any = {};

        if (emphasize) {
            style1.color = '#1111ee';
        }

        return <span style={style1}>{axisType}</span>;
    }

    getDataType(value) {
        let axisName = value.type;

        if (axisName === 'arguments') {
            return ChartPropsManager.get_argumentAxis_DataType_withTimePart(this.props.values, this.props.glob);
        } else if (axisName === 'values') {
            return ChartPropsManager.get_valueAxis_DataType_withTimePart(this.props.values, this.props.glob);
        }
        //LL: 02.06.20: add 'not used' type => will not used in Chart
        else if (axisName === CHART_STRIPS.notUsedType) {
            // nothing
        } else {
            return ChartPropsManager.get_secondaryAxis_DataType_withTimePart(
                this.props.values,
                axisName,
                this.props.themeObj,
                this.props.glob
            );
        }

        return undefined;
    }

    getStartValue(value, dataType) {
        if (value.type == null) {
            return;
        }

        let fromDataSourceStart = value.fromDataSourceStart != null ? value.fromDataSourceStart : false;
        if (fromDataSourceStart) {
            //let dataQueryValueStart = value.dataQueryStart;  // may be null

            //LL: 26.10.19: make copy:  it is array[0] or null
            let dataQueryValueStart: any = null;
            if (value.dataQueryStart != null && value.dataQueryStart.length > 0) {
                let v: any = value.dataQueryStart[0];
                v = $.extend(true, {}, v); // deep copy
                dataQueryValueStart = [v];
            }

            return (
                <DataQuerySingleValueField
                    value={dataQueryValueStart}
                    themeObj={this.props.themeObj}
                    onChange={this.processStartDataQueryChange}
                    glob={this.props.glob}
                />
            );
        } else {
            let displayVal2 = value.startValue || '';

            let placeholder = '';
            //if (DateTimeFunctions.isTypeOfDateOrDatetime(dataType)) {
            //    placeholder = 'yyyy-mm-dd hh:mm:ss';
            //}
            //LL: 19.06.24
            if (DateTimeFunctions.isTypeOfDatetime(dataType)) {
                placeholder = 'yyyy-mm-dd hh:mm:ss';
            } else if (DateTimeFunctions.isTypeOfDatePure(dataType)) {
                placeholder = 'yyyy-mm-dd';
            } else if (DateTimeFunctions.isTypeOfTime(dataType)) {
                placeholder = 'hh:mm:ss';
            }

            //  NEW:
            let title = placeholder !== '' ? placeholder : null;

            return (
                <StringField
                    onChange={this.processStartValueChange}
                    value={displayVal2}
                    placeholder={placeholder}
                    title={title}
                />
            );
        }
    }

    getEndValue(value, dataType) {
        if (value.type == null) {
            return;
        }

        let fromDataSourceEnd = value.fromDataSourceEnd != null ? value.fromDataSourceEnd : false;
        if (fromDataSourceEnd) {
            //let dataQueryValueEnd = value.dataQueryEnd;  // may be null

            //LL: 26.10.19: make copy:  it is array[0] or null
            let dataQueryValueEnd: any = null;
            if (value.dataQueryEnd != null && value.dataQueryEnd.length > 0) {
                let v: any = value.dataQueryEnd[0];
                v = $.extend(true, {}, v); // deep copy
                dataQueryValueEnd = [v];
            }

            return (
                <DataQuerySingleValueField
                    value={dataQueryValueEnd}
                    themeObj={this.props.themeObj}
                    onChange={this.processEndDataQueryChange}
                    glob={this.props.glob}
                />
            );
        } else {
            let displayVal2 = value.endValue || '';

            let placeholder = '';
            //if (DateTimeFunctions.isTypeOfDateOrDatetime(dataType)) {
            //    placeholder = 'yyyy-mm-dd hh:mm:ss';
            //}
            //LL: 19.06.24
            if (DateTimeFunctions.isTypeOfDatetime(dataType)) {
                placeholder = 'yyyy-mm-dd hh:mm:ss';
            } else if (DateTimeFunctions.isTypeOfDatePure(dataType)) {
                placeholder = 'yyyy-mm-dd';
            } else if (DateTimeFunctions.isTypeOfTime(dataType)) {
                placeholder = 'hh:mm:ss';
            }

            //  NEW:
            let title = placeholder !== '' ? placeholder : null;

            return (
                <StringField
                    onChange={this.processEndValueChange}
                    value={displayVal2}
                    placeholder={placeholder}
                    title={title}
                />
            );
        }
    }

    getFontColor(value) {
        if (value.type == null) {
            return;
        }

        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.themeFields_forDefaultColors;

        let defaultColor = '#000000';
        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.color != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorFont;
        }

        let options: any = {
            hideTransparency: true
        };

        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null
                ? themeFields_forDefaultColors.themeFieldForDefault_colorFont_strips
                : null;
        let displayVal = value.fontColor || themeObj[themeFieldForDefault_color] || defaultColor;

        let param: any = {
            defaultVal: () => {
                return themeObj[themeFieldForDefault_color] || defaultColor;
            },
            glob: this.props.glob,
            options: options
        };

        return (
            <ParameterField
                key="parameter-field"
                param={param}
                options={{
                    inline: true,
                    noTitle: true,
                    clearable: true,
                    onClear: () => this.processFontColorChange_ColorBox(null)
                }}
                glob={this.props.glob}
            >
                <ColorBoxField
                    value={displayVal}
                    themeObj={themeObj}
                    hideTransparency={true}
                    showText={false}
                    options={options}
                    param={param}
                    onChange={this.processFontColorChange_ColorBox}
                    glob={this.props.glob}
                />
            </ParameterField>
        );
    }

    getColor(value) {
        if (value.type == null) {
            return;
        }

        let themeObj = this.props.themeObj;
        let themeFields_forDefaultColors = this.props.themeFields_forDefaultColors;

        let defaultColor = '#dae0f7'; //LL: DevExpress sample
        if (
            themeFields_forDefaultColors != null &&
            themeFields_forDefaultColors.defaultColors_static != null &&
            themeFields_forDefaultColors.defaultColors_static.color != null
        ) {
            defaultColor = themeFields_forDefaultColors.defaultColors_static.colorBack;
        }

        let options: any = {
            hideTransparency: true
        };

        let themeFieldForDefault_color =
            themeFields_forDefaultColors != null ? themeFields_forDefaultColors.themeFieldForDefault_colorBack : null;
        let displayVal = value.color || themeObj[themeFieldForDefault_color] || defaultColor;

        let param: any = {
            defaultVal: () => {
                return themeObj[themeFieldForDefault_color] || defaultColor;
            },
            glob: this.props.glob,
            options: options
        };

        //LL: was changed enormously by OE in Nov 2018: added ParameterField for inheritance ==========

        //LL: this results in: added internaly class = "form-group", that has margin-bottom: 1rem
        //   see fixes in sass

        return (
            <ParameterField
                key="parameter-field"
                param={param}
                options={{
                    inline: true,
                    noTitle: true,
                    clearable: true,
                    onClear: () => this.processColorChange_ColorBox(null)
                }}
                glob={this.props.glob}
            >
                <ColorBoxField
                    value={displayVal}
                    themeObj={themeObj}
                    hideTransparency={false}
                    showText={false}
                    options={options}
                    param={param}
                    onChange={this.processColorChange_ColorBox}
                    glob={this.props.glob}
                />
            </ParameterField>
        );
    }

    getLabelVerticalAlignment(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.labelVerticalAlignment; // || 'none';

        let options = _.map(CHART_STRIPS.labelVerticalAlignment, function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.labelVerticalAlignment = input;
                }}
                className="form-control"
                value={displayVal}
                onChange={this.processLabelVerticalAlignmentChange}
            >
                {options}
            </select>
        );
    }

    getLabelHorizontalAlignment(value) {
        if (value.type == null) {
            return;
        }

        let displayVal = value.labelHorizontalAlignment; // || 'none';

        let options = _.map(CHART_STRIPS.labelHorizontalAlignment, function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.labelHorizontalAlignment = input;
                }}
                className="form-control"
                onChange={this.processLabelHorizontalAlignmentChange}
                value={displayVal}
            >
                {options}
            </select>
        );
    }

    getAsPercent(value) {
        if (value.type == null) {
            return;
        }

        let disabled = false;

        if (value.type === 'arguments') {
            if (!disabled) {
                if (this.props.prohibitedAsPercent_byAxisType_byAxisObjX != null) {
                    disabled = this.props.prohibitedAsPercent_byAxisType_byAxisObjX;
                }
            }

            if (!disabled) {
                if (this.props.prohibitedAsPercent_byAttrQuery_X_multi != null) {
                    disabled = this.props.prohibitedAsPercent_byAttrQuery_X_multi;
                }
            }
        } else if (value.type === 'values') {
            if (!disabled) {
                if (this.props.prohibitedAsPercent_byAxisType_byAxisObjY != null) {
                    disabled = this.props.prohibitedAsPercent_byAxisType_byAxisObjY;
                }
            }

            if (!disabled) {
                if (this.props.prohibitedAsPercent_byAttrQuery_Y_multi != null) {
                    disabled = this.props.prohibitedAsPercent_byAttrQuery_Y_multi;
                }
            }
        }
        //LL: 02.06.20:  add 'not used' type => will not used in Chart
        else if (value.type === CHART_STRIPS.notUsedType) {
            disabled = true;
        }
        //LL: AuxAxis:  similar to Values
        else {
            let axisName = value.type;

            if (!disabled) {
                disabled = ChartPropsManager.prohibitAsPercent_SecondaryValueAxis(
                    this.props.values,
                    axisName,
                    this.props.themeObj,
                    this.props.glob
                );
            }
        }

        return (
            <input
                ref={(input) => {
                    this.references.asPercent = input;
                }}
                type="checkbox"
                disabled={disabled}
                title="only for numeric continuous axis"
                checked={value.asPercent}
                onChange={this.processAsPercentChange}
            />
        );
    }

    getFromDataSourceStart(value) {
        if (value.type == null) {
            return;
        }

        let checkedVal = value.fromDataSourceStart != null ? value.fromDataSourceStart : false;

        return (
            <input
                ref={(input) => {
                    this.references.fromDataSourceStart = input;
                }}
                type="checkbox"
                title="get Start Value from DataSource"
                checked={checkedVal}
                onChange={this.processFromDataSourceStartChange}
            />
        );
    }

    getFromDataSourceEnd(value) {
        if (value.type == null) {
            return;
        }

        let checkedVal = value.fromDataSourceEnd != null ? value.fromDataSourceEnd : false;

        return (
            <input
                ref={(input) => {
                    this.references.fromDataSourceEnd = input;
                }}
                type="checkbox"
                title="get End Value from DataSource"
                checked={checkedVal}
                onChange={this.processFromDataSourceEndChange}
            />
        );
    }

    render() {
        const value = this.props.value || {};
        const dataTypeExt = this.getDataType(value);

        let dataType;
        let dataTypePure;
        let dataTimePart;

        if (dataTypeExt != null) {
            dataType = dataTypeExt.type;

            if (dataTypeExt.timePart != null && dataTypeExt.timePart !== 'none') {
                dataType = dataTypeExt.timePart;
            }

            dataTypePure = dataTypeExt.type;
            dataTimePart = dataTypeExt.timePart;
        } else {
            dataType = 's';
            dataTypePure = 's';
        }

        //LL: 01.06.20:  must have "name"   className="cell-name"
        //let tdName =
        //    <td className="cell-name">
        //        { this.getName(value) }
        //    </td>;
        //LL: 19.11.20:  //handle: '.cell-drag' in $(tableBody).sortable
        //    See problem description in getName of ChartBreaksField_inThemes.tsx
        //    (clicking on this (empty) field does not issue onBlur for currently edited <input>)
        let nameElem = this.getName(value);
        let nameClass = 'cell-name';
        if (nameElem != null) {
            nameClass += ' cell-drag';
        }
        let tdName = <td className={nameClass}>{nameElem}</td>;

        return (
            <tr>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                {tdName}
                <td className="cell-type">{this.getType(value)}</td>
                <td className="cell-axisType">{this.getAxisType(value)}</td>
                <td className="cell-label">{this.getLabel(value)}</td>
                <td className="cell-asPercent">{this.getFromDataSourceStart(value)}</td>
                <td className="cell-startValue">{this.getStartValue(value, dataType)}</td>
                <td className="cell-asPercent">{this.getFromDataSourceEnd(value)}</td>
                <td className="cell-endValue">{this.getEndValue(value, dataType)}</td>
                <td className="cell-asPercent">{this.getAsPercent(value)}</td>
                <td className="cell-color">{this.getColor(value)}</td>
                <td className="cell-color">{this.getFontColor(value)}</td>
                <td className="cell-labelAlignment">{this.getLabelVerticalAlignment(value)}</td>
                <td className="cell-labelAlignment">{this.getLabelHorizontalAlignment(value)}</td>
            </tr>
        );
    }
}

export interface IChartStripsField_inThemesOptions extends IParameterFieldBaseOptions {
    widgetTypeName?: string;
    widgetValues?;
    themeFieldForStripList?;
    themeFields_forLabelAlignment;
    themeFields_forDefaultColors;
    prohibitAsPercent_byAxisType_byAxisObjX_Func(values, theme: appTheme.IValuesCollection): boolean;
    prohibitAsPercent_byAxisType_byAxisObjY_Func(values, theme: appTheme.IValuesCollection): boolean;
    prohibitAsPercent_byAttrQuery_X_multi_Func(values, glob: IGlob): boolean;
    prohibitAsPercent_byAttrQuery_Y_multi_Func(values, glob: IGlob): boolean;
    onEvalAuxAxisNames(chartAxisArrayField);
}

export default class ChartStripsField_inThemes extends React.Component<
    {
        value?: any[];
        border: boolean;
        options?: IChartStripsField_inThemesOptions;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value): void;
    },
    { forActualChart: boolean }
> {
    //LL: 02.06.20: StandardInheritanceFlag, when full inheritance.  Must have "name" field now, old values have no names
    //     no dependancy on level, old values were only on Widget level
    //LL: Where to use it ?  Not needed in main.ts
    //public static normalizeStatic(value) {
    //    if (StandardInheritanceFlag) {
    //        //LL:  value is this.props.value, is array
    //        if (value != null) {
    //            let cnt = 0;
    //            _.each(value, function (obj: any, index) {  // obj is a Strip
    //                if (obj.name == null) {
    //                    cnt++;
    //                    obj.name = 'strip' + cnt;
    //                }
    //            })
    //        }
    //    }
    //}

    private references: {
        tableBody?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        let forActualChart = true; //LL: 28.05.20  false when with standard inheritance, on upper levels
        let props_values = this.getPropsValues();

        if (props_values == null) {
            forActualChart = false; //LL: 28.05.20: when with standard inheritance, on upper levels
        }

        this.state = {
            forActualChart: forActualChart
        };
    }

    private startIndex;

    reorderStart = (e, ui) => {
        this.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (this.startIndex == null) {
            return;
        }

        let startIndex = this.startIndex;
        let stopIndex = $(ui.item).index();

        this.startIndex = null;

        //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");

        let tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        let tableBody = this.references.tableBody;

        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr:not(.empty)',
            opacity: 0.8,
            //handle: '.cell-name',
            handle: '.cell-drag', //LL: 19.11.20: in addition to cell-name
            start: this.reorderStart,
            stop: this.reorderStop
        });
    }

    componentWillUnmount() {
        let tableBody = this.references.tableBody;
        $(tableBody).sortable('destroy');
    }

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);

        let item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.handleValueChange(value);
    }

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    getPropsValues() {
        let pv;

        if (this.props.options != null && this.props.options.widgetValues != null) {
            if (this.props.options.widgetTypeName === 'pdc-widget-chart') {
                pv = this.props.options.widgetValues;
            }
        }
        return pv;
    }

    getChartAxisArrayField() {
        let props_values = this.getPropsValues();

        if (props_values == null) {
            return [];
        }

        const result = ChartPropsManager.getChartAxisArray(props_values, this.props.themeObj);

        // if (this.props.options != null && typeof this.props.options.getChartAxisArray_Func === 'function') {
        //     result = this.props.options.getChartAxisArray_Func(props_values, this.props.themeObj);
        // }

        return result;
    }

    addRow = (obj: any, selectedPredefinedStripName?) => {
        let arr = this.props.value.slice(0);

        let labelAlignmentVert_X = 'top';
        let labelAlignmentHoriz_X = 'center';
        let labelAlignmentVert_Y = 'center';
        let labelAlignmentHoriz_Y = 'left';
        let labelAlignmentHoriz_A = 'right'; //LL: now without theme default

        if (this.props.themeObj != null) {
            let themeFields_forLabelAlignment = this.props.options.themeFields_forLabelAlignment;

            if (themeFields_forLabelAlignment != null) {
                if (themeFields_forLabelAlignment.labelAlignmentVert_X != null) {
                    labelAlignmentVert_X = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentVert_X];
                }
                if (themeFields_forLabelAlignment.labelAlignmentHoriz_X != null) {
                    labelAlignmentHoriz_X = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentHoriz_X];
                }
                if (themeFields_forLabelAlignment.labelAlignmentVert_Y != null) {
                    labelAlignmentVert_Y = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentVert_Y];
                }
                if (themeFields_forLabelAlignment.labelAlignmentHoriz_Y != null) {
                    labelAlignmentHoriz_Y = this.props.themeObj[themeFields_forLabelAlignment.labelAlignmentHoriz_Y];
                }
            }
        }

        //LL:  if rotatedXY  ???
        if (obj.type === 'arguments') {
            // strip looks vertical, if not rotated
            obj.labelHorizontalAlignment = labelAlignmentHoriz_X; //'center';
            obj.labelVerticalAlignment = labelAlignmentVert_X; //'top';
        } else if (obj.type === 'values') {
            // strip looks horizontal, if not rotated
            obj.labelHorizontalAlignment = labelAlignmentHoriz_Y; //'left';
            obj.labelVerticalAlignment = labelAlignmentVert_Y; //'center';
        }
        //LL: 02.06.20:  add 'not used' type => will not used in Chart
        else if (obj.type === CHART_STRIPS.notUsedType) {
            //  nothing (is null) or as X  ?
        } else {
            // AuxAxis, strip looks horizontal, if not rotated
            obj.labelHorizontalAlignment = labelAlignmentHoriz_A; //'right';
            obj.labelVerticalAlignment = labelAlignmentVert_Y; //'center';
        }

        obj.asPercent = false;

        let selectedPredefinedStripObj;

        if (selectedPredefinedStripName != null) {
            let themeFieldForStripList = this.props.options.themeFieldForStripList;
            let themeObj = this.props.themeObj;

            if (themeFieldForStripList != null && themeObj != null) {
                let stripList = themeObj[themeFieldForStripList];

                if (stripList != null && stripList.length > 0) {
                    selectedPredefinedStripObj = _.find(stripList, (obj) => {
                        return obj.name === selectedPredefinedStripName;
                    });
                }
            }
        }

        if (selectedPredefinedStripObj != null) {
            obj = $.extend(true, {}, obj, selectedPredefinedStripObj); // deep copy because of DataSource Start/End Values
            delete obj.name; //LL:  === predefinedName
        }

        arr.push(obj);
        this.handleValueChange(arr);
    };

    handleOnChangeRow = (obj: any, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    };

    handleOnRemoveRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    callEvalAuxAxisNames(ChartAxisArrayField) {
        let result = '';

        if (this.props.options != null && typeof this.props.options.onEvalAuxAxisNames === 'function') {
            result = this.props.options.onEvalAuxAxisNames(ChartAxisArrayField);
        }

        return result;
    }

    render() {
        const { options } = this.props;
        const forActualChart = this.state.forActualChart; // false - when with standard inheritance, on upper levels
        const props_values = this.getPropsValues();

        if (props_values == null) {
            //return null;
            //LL: 28.05.20:
            //if (!StandardInheritanceFlag) {  // as old
            //    return null;
            //}
        }

        //let secondaryAxis;
        let secondaryAxisArr = [];
        //let multiAxis = true;
        const chartAxisArrayField = this.getChartAxisArrayField();
        const auxAxisNames = this.callEvalAuxAxisNames(chartAxisArrayField);

        if (auxAxisNames != null && auxAxisNames != '') {
            secondaryAxisArr = auxAxisNames.split(';');
        }

        //secondaryAxis = AuxAxisNames;

        //  -- prohibit by AxisType:
        let prohibitedAsPercent_byAxisType_byAxisObjX: boolean;
        let prohibitedAsPercent_byAxisType_byAxisObjY: boolean;
        //  -- prohibit by ValueType:
        let prohibitedAsPercent_byAttrQuery_X_multi: boolean;
        let prohibitedAsPercent_byAttrQuery_Y_multi: boolean;

        if (forActualChart) {
            if (typeof options?.prohibitAsPercent_byAxisType_byAxisObjX_Func === 'function') {
                prohibitedAsPercent_byAxisType_byAxisObjX = options.prohibitAsPercent_byAxisType_byAxisObjX_Func(
                    props_values,
                    this.props.themeObj
                );
            }

            if (typeof options?.prohibitAsPercent_byAxisType_byAxisObjY_Func === 'function') {
                prohibitedAsPercent_byAxisType_byAxisObjY = options.prohibitAsPercent_byAxisType_byAxisObjY_Func(
                    props_values,
                    this.props.themeObj
                );
            }

            if (typeof options?.prohibitAsPercent_byAttrQuery_X_multi_Func === 'function') {
                prohibitedAsPercent_byAttrQuery_X_multi = options.prohibitAsPercent_byAttrQuery_X_multi_Func(
                    props_values,
                    this.props.glob
                );
            }

            if (typeof options?.prohibitAsPercent_byAttrQuery_Y_multi_Func === 'function') {
                prohibitedAsPercent_byAttrQuery_Y_multi = options.prohibitAsPercent_byAttrQuery_Y_multi_Func(
                    props_values,
                    this.props.glob
                );
            }
        }

        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let rows = _.map(this.props.value, (obj, index) => {
            let obj2 = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'ChartStripsField_inThemes');
            //LL: may be null, if just removed
            if (obj2 == null) {
                return null;
            }

            return (
                <ChartStripsFieldRow
                    key={index + '-' + obj2.type}
                    index={index}
                    value={obj2}
                    values={props_values}
                    themeFields_forDefaultColors={options.themeFields_forDefaultColors}
                    //themeFieldForStripList={options.themeFieldForStripList}
                    prohibitedAsPercent_byAxisType_byAxisObjX={prohibitedAsPercent_byAxisType_byAxisObjX}
                    prohibitedAsPercent_byAxisType_byAxisObjY={prohibitedAsPercent_byAxisType_byAxisObjY}
                    secondaryAxisArr={secondaryAxisArr}
                    prohibitedAsPercent_byAttrQuery_X_multi={prohibitedAsPercent_byAttrQuery_X_multi}
                    prohibitedAsPercent_byAttrQuery_Y_multi={prohibitedAsPercent_byAttrQuery_Y_multi}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                    onChange={this.handleOnChangeRow}
                    onRemove={this.handleOnRemoveRow}
                />
            );
        });

        let thName = <th className="cell-name">{'Name'}</th>;

        //LL: 19.06.24: Date vs DateTime
        //   <p>Start/End Values: format for Dates is 'yyyy-mm-dd hh:mm:ss', for Time is 'hh:mm:ss'</p>
        //LL: use cell-color for both color and fontColor
        return (
            <div className={'chartstrips-field'}>
                <div className="chartstrips-field-common">
                    <p>
                        Start/End Values: format for DateTime is 'yyyy-mm-dd hh:mm:ss', for Date is 'yyyy-mm-dd', for
                        Time is 'hh:mm:ss'
                    </p>
                    <p>"As Percent" can be used only for numeric continuous axis</p>
                </div>
                <div className={'div-container'}>
                    <div className="chartstrips-field-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')}>
                        <thead>
                            <tr>
                                <th className="cell-remove"></th>
                                {thName}
                                <th className="cell-type">Axis</th>
                                <th className="cell-axisType">Axis Type</th>
                                <th className="cell-label">Label</th>
                                <th className="cell-asPercent" title="get Start Value from DataSource">
                                    {'From Data Source'}
                                </th>
                                <th
                                    className="cell-startValue"
                                    title="format for DateTime 'yyyy-mm-dd hh:mm:ss', for Date 'yyyy-mm-dd', for Time 'hh:mm:ss'"
                                >
                                    {'Start Value / Data Source'}
                                </th>
                                <th className="cell-asPercent" title="get End Value from DataSource">
                                    {'From Data Source'}
                                </th>
                                <th
                                    className="cell-endValue"
                                    title="format for DateTime 'yyyy-mm-dd hh:mm:ss', for Date 'yyyy-mm-dd', for Time 'hh:mm:ss'"
                                >
                                    {'End Value / Data Source'}
                                </th>
                                <th className="cell-asPercent">As Percent</th>
                                <th className="cell-color">Color</th>
                                <th className="cell-color">Font Color</th>
                                <th className="cell-labelAlignment">Label Vertical Alignment</th>
                                <th className="cell-labelAlignment">Label Horizontal Alignment</th>
                            </tr>
                        </thead>

                        <tbody
                            ref={(input) => {
                                this.references.tableBody = input;
                            }}
                        >
                            {rows}
                            <ChartStripsFieldRow
                                secondaryAxisArr={secondaryAxisArr}
                                themeObj={this.props.themeObj}
                                //themeFieldForStripList={options.themeFieldForStripList}
                                glob={this.props.glob}
                                onChange={this.addRow}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
